import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
export class FormlyFieldTextArea extends FieldType {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-field-textarea',
  template: `
    <textarea [name]="key" [formControl]="formControl" [cols]="to.cols"
      [rows]="to.rows" class="form-control" [class.is-invalid]="showError"
      [formlyAttributes]="field">
    </textarea>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyFieldTextArea_tsickle_Closure_declarations() {
/** @type {?} */
FormlyFieldTextArea.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyFieldTextArea.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
